import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'

function useMutationDeleteAutoMessage(
	props?: UseBaseMutationOptions<void, string>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.DeleteAutoMessage],
		mutationFn: (id: string) => MessagingService.deleteAutoMessage(id),
		...props,
	})
}

export default useMutationDeleteAutoMessage
